// -----------------------------------------------------------------------------
// Scripts
// -----------------------------------------------------------------------------

$.fn.preload = function () {
    this.each(function () {
        $('<img/>')[0].src = this;
    });
}

var SCRIPTS = SCRIPTS || {};

$(document).ready(function () {
    SCRIPTS = {
        settings: {},
        init: function () {
            if ($('.js-skifield').length > 0) {
                this.skifieldtables.init();
            }
        },

        skifieldtables: {
            skifields: $('.js-skifield'),
            numfields: null,
            eachheight: 0,
            slidetime: 7000,
            body: null,
            backstretchImages: [],
            init: function () {
                var _this = this;
                _this.numfields = this.skifields.length;
                _this.doanimations(1);

                $(window).resize(function () {
                    _this.doresize();
                });
            },
            doanimations: function (setup) {
                var _this = this;
                var windowheight = $(window).innerHeight();
                _this.eachheight = (windowheight / _this.numfields);
                var paddingtop = (_this.eachheight * (_this.numfields - 1));
                _this.flipgap = 150;
                var runningheight = 0;
                _this.body = $('body').height(windowheight);

                if (setup) {
                    _this.backstretchImages.push(_this.body.data('image'));
                }

                this.skifields.each(function () {
                    $(this).find('table').height(_this.eachheight);

                    if (setup) {
                        $(this).flip(
                            {
                                front: 'div.front',
                                back: 'div.back',
                                axis: 'x',
                                trigger: 'manual'
                            }
                        );

                        _this.backstretchImages.push($(this).data('bg'));
                    }

                    $(this).css(
                        {
                            'height': _this.eachheight + 'px',
                            'position': 'absolute',
                            'top': runningheight + 'px',
                            'bottom': 'auto'
                        }
                    );

                    runningheight += _this.eachheight;
                });

                if (setup) {
                    $(_this.backstretchImages).preload();
                }

                $.backstretch(_this.backstretchImages[0], { transitionDuration: 500 });

                var delay = _this.slidetime;
                this.skifields.each(function () {
                    delay += _this.flipgap;
                    setTimeout(function (flip) {
                        flip.flip(true).toggleClass("flipactive");
                    }, delay, $(this));
                });

                delay += (_this.flipgap * 4);

                setTimeout(function () {
                    _this.doflipback(0, delay);
                }, delay);
            },
            doresize: function () {
                var _this = this;
                var windowheight = $(window).innerHeight();
                _this.eachheight = (windowheight / _this.numfields);
                _this.body = $('body').height(windowheight);
                var runningheight = 0;
                var x = 1;

                this.skifields.each(function () {
                    $(this).find('table').height(_this.eachheight);

                    $(this).css('height', _this.eachheight + 'px');

                    if ($(this).css('bottom') != '0px' || x == 4) {
                        $(this).css('top', runningheight + 'px');
                    }

                    runningheight += _this.eachheight;
                    x++;
                });
            },
            doflipback: function (x, delay) {
                var _this = this;

                setTimeout(function (x) {
                    if (x > 0) {
                        var flipbackbefore = _this.skifields.eq(x - 1);
                        flipbackbefore.flip(true).toggleClass("flipactive");
                    }
                    var flipback = _this.skifields.eq(x);

                    flipback.css(
                        {
                            'top': 'auto',
                            'bottom': 0
                        }
                    ).flip(false).toggleClass("flipactive");

                }, delay, x);

                // Separate timeout for backstretch timing
                setTimeout(function (i) {
                    $.backstretch(_this.backstretchImages[i + 1], { transitionDuration: 500 });

                }, (delay - 200), x);

                setTimeout(function (x) {
                    if (_this.numfields == x) {
                        _this.dodefault(x, delay);
                    } else {
                        _this.doflipback(x, delay);
                    }
                }, _this.slidetime + delay, (x + 1));
            },
            dodefault: function (x, delay) {
                var _this = this;

                setTimeout(function (x) {
                    var flipbackbefore = _this.skifields.eq(x - 1);
                    flipbackbefore.flip(true).toggleClass("flipactive");
                    $.backstretch(_this.backstretchImages[0], { transitionDuration: 500 });
                }, delay, x);

                setTimeout(function () {
                    _this.doreset();
                }, _this.slidetime + delay);
            },
            doreset: function () {
                var _this = this;
                var runningheight = 0;

                var delay = _this.slidetime + (_this.flipgap * _this.numfields);
                var delayrestart = (delay * 2);

                this.skifields.each(function () {
                    $(this).css(
                        {
                            'top': runningheight + 'px',
                            'bottom': 'auto'
                        }
                    );

                    runningheight += _this.eachheight;

                    setTimeout(function (flip) {
                        flip.flip(false).toggleClass("flipactive");
                    }, delay, $(this));

                    delay -= _this.flipgap;
                });

                setTimeout(function () {
                    _this.doanimations(0);
                }, delayrestart);
            }
        }
    }

    SCRIPTS.init();
});
